module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CXqH1E/tc-custom/9781439628515.jpg?1684245186036",
      "alt": "This image is the cover for the book New York City Subways, Postcard History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New York City Subways, Postcard History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("New York City Subways traces the history of mass transportation in Manhattan and New York City's outer boroughs. Public transportation has long been vital to the city, with horse-drawn surface lines established by 1831 and elevated railroad lines constructed during the 1870s and 1880s. The concept of subways, railroads operating underground, originated in London in 1863 and was applied to New York City by 1904. This collection of vintage postcards brings you through the tunnels of the subway, onto the platforms of the long-gone els, and examines New York's renowned terminals, especially Grand Central and Penn Station.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tom Range Sr.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tom Range Sr. is a native New Yorker and, since his high school days fifty years ago, a straphanger on its subway and els. As a New York City resident, he was associated with the Metropolitan Postcard Collectors Club in Manhattan. Today, he is an active member of the Washington Crossing Card Collectors Club in Titusville, New Jersey.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0